module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"articleTitle":"Best laptop for {0}","tabs":["Write","Export"],"submit":"Save","autoSave":"Auto-save"}}')
  delete Component.options._Ctor
}
